<template>
  <v-list class="prevent-overflow pa-0">
    <v-container>
      <v-layout>
        <v-flex class="headline text-xs-center">{{$t('announcements.panel.title')}}</v-flex>
      </v-layout>
    </v-container>
    <announcement-panel-row v-for="(announcement, key) in announcements" :key="key"
                            :icon="severityIconList[announcement.severity]" :message="announcement.message"
                            :icon-color="severityColorList[announcement.severity]">
    </announcement-panel-row>
  </v-list>
</template>
<script>
  import AnnouncementPanelRow from './AnnouncementPanelRow'

  export default {
    name: 'announcement-panel',
    components: {AnnouncementPanelRow},
    props: {
      severityColorList: {
        required: true,
        type: Object
      },
      severityIconList: {
        required: true,
        type: Object
      },
      announcements: {
        required: true,
        type: Array
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/announcement/AnnouncementPanel.vue